const Pagination = ({ page, totalPages, setPage, limit, setLimit, totalDocs }) => {
console.log( page, limit, totalPages, totalDocs );


  const pageNumbers = [];
  const maxVisible = 5; // how many page numbers to show

  let start = Math.max(1, page - Math.floor(maxVisible / 2));
  let end = Math.min(totalPages, start + maxVisible - 1);

  if (end - start < maxVisible - 1) {
    start = Math.max(1, end - maxVisible + 1);
  }

  for (let i = start; i <= end; i++) {
    pageNumbers.push(i);
  }

  // calculate showing range
  const startItem = (page - 1) * limit + 1;
  const endItem = Math.min(page * limit, totalDocs);

  return (
    <div className="flex justify-between items-center mt-4">
      {/* Left: Showing X–Y of Z */}
      <div className="text-sm text-gray-600">
        Showing <span className="font-medium">{startItem}</span>–
        <span className="font-medium">{endItem}</span> of{" "}
        <span className="font-medium">{totalDocs}</span>
      </div>

      {/* Middle: Pagination buttons */}
      <div className="inline-flex items-center gap-1">
        {/* Prev */}
        <button
          disabled={page === 1}
          onClick={() => setPage(page - 1)}
          className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
        >
          Prev
        </button>

        {/* First page + ellipsis */}
        {start > 1 && (
          <>
            <button
              onClick={() => setPage(1)}
              className={`px-3 py-1 rounded ${
                page === 1
                  ? "bg-[#d3178a] text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              1
            </button>
            {start > 2 && <span className="px-2">...</span>}
          </>
        )}

        {/* Middle pages */}
        {pageNumbers.map((num) => (
          <button
            key={num}
            onClick={() => setPage(num)}
            className={`px-3 py-1 rounded ${
              page === num
                ? "bg-[#d3178a] text-white"
                : "bg-gray-200 hover:bg-gray-300"
            }`}
          >
            {num}
          </button>
        ))}

        {/* Last page + ellipsis */}
        {end < totalPages && (
          <>
            {end < totalPages - 1 && <span className="px-2">...</span>}
            <button
              onClick={() => setPage(totalPages)}
              className={`px-3 py-1 rounded ${
                page === totalPages
                  ? "bg-[#d3178a] text-white"
                  : "bg-gray-200 hover:bg-gray-300"
              }`}
            >
              {totalPages}
            </button>
          </>
        )}

        {/* Next */}
        <button
          disabled={page === totalPages}
          onClick={() => setPage(page + 1)}
          className="px-3 py-1 bg-gray-200 rounded hover:bg-gray-300 disabled:opacity-50"
        >
          Next
        </button>
      </div>

      {/* Right: Page size dropdown */}
      <div className="text-sm">
        <select
          value={limit}
          onChange={(e) => {
            setLimit(Number(e.target.value));
            setPage(1); // reset to first page when limit changes
          }}
          className="border rounded px-4 py-1"
        >
          {[10, 20, 50, 100].map((size) => (
            <option key={size} value={size}>
              {size} / page
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};


export default Pagination